import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DashboardLayout from "../../layouts/DashboardLayout";
import { api } from "../../api/client";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  const [owners, setOwners] = useState([]);

  useEffect(() => {
    api("/api/admin/stats").then(setStats);
    api("/api/admin/owners").then(setOwners);
  }, []);

  return (
    <DashboardLayout title="Atelier overview">
      <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
        <Tile color="bg-blush" label="Owners" value={stats?.owners ?? "—"} />
        <Tile color="bg-lilac" label="Venues" value={stats?.venues ?? "—"} />
        <Tile color="bg-gold-soft" label="Published" value={stats?.published ?? "—"} />
        <Tile color="bg-teal/40" label="Pending books" value={stats?.pending ?? "—"} />
      </div>

      <section className="card mt-8 p-6">
        <div className="flex items-center justify-between">
          <h2 className="font-serif text-2xl">House owners</h2>
          <Link to="/admin/accounts" className="btn-ink">
            Manage accounts
          </Link>
        </div>
        <div className="mt-5 divide-y divide-ink/5">
          {owners.map((owner) => (
            <div key={owner.id} className="flex flex-wrap items-center justify-between gap-3 py-3">
              <div>
                <p className="font-medium">{owner.name}</p>
                <p className="text-sm text-ink/50">{owner.email}</p>
              </div>
              <p className="text-sm text-ink/60">
                {owner.venue?.name || "No venue"} · {owner.venue?.published ? "live" : "draft"}
              </p>
            </div>
          ))}
        </div>
      </section>
    </DashboardLayout>
  );
}

function Tile({ color, label, value }) {
  return (
    <div className={`rounded-[1.6rem] ${color} p-5`}>
      <p className="text-xs uppercase tracking-[0.18em] text-ink/50">{label}</p>
      <p className="mt-2 font-serif text-4xl">{value}</p>
    </div>
  );
}
